var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { Box, TextField as MuiTextField } from '@mui/material';
import { format, isValid, parse } from 'date-fns';
var DateRangeFilter = function (_a) {
    var _b, _c;
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged;
    var handleChange = React.useCallback(function (date, key) {
        var _a;
        var value = (_a = {}, _a[key] = date ? format(date, 'yyyy-MM-dd') : null, _a);
        onFilterChanged(columnDef.tableData.id, columnDef.tableData.filterValue
            ? Object.assign(columnDef.tableData.filterValue, value)
            : value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement(Box, { display: "block", sx: {
            minWidth: 120,
        } },
        React.createElement(DesktopDatePicker, { inputFormat: "yyyy-MM-dd", value: ((_b = columnDef.tableData.filterValue) === null || _b === void 0 ? void 0 : _b.startedAt) || null, onChange: function (date, keyboardInputValue) {
                if (keyboardInputValue) {
                    var keyboardInputDate = parse(keyboardInputValue, 'yyyy-MM-dd', new Date());
                    isValid(keyboardInputDate) &&
                        handleChange(keyboardInputDate, 'startedAt');
                }
                else {
                    handleChange(date, 'startedAt');
                }
            }, renderInput: function (inputProps) { return (React.createElement(MuiTextField, __assign({}, inputProps, { label: "From", variant: "standard", margin: "none", fullWidth: true }))); } }),
        React.createElement("br", null),
        React.createElement(DesktopDatePicker, { inputFormat: "yyyy-MM-dd", value: ((_c = columnDef.tableData.filterValue) === null || _c === void 0 ? void 0 : _c.endedAt) || null, onChange: function (date, keyboardInputValue) {
                if (keyboardInputValue) {
                    var keyboardInputDate = parse(keyboardInputValue, 'yyyy-MM-dd', new Date());
                    isValid(keyboardInputDate) &&
                        handleChange(keyboardInputDate, 'endedAt');
                }
                else {
                    handleChange(date, 'endedAt');
                }
            }, renderInput: function (inputProps) { return (React.createElement(MuiTextField, __assign({}, inputProps, { label: "To", variant: "standard", margin: "none", fullWidth: true }))); } })));
};
export default DateRangeFilter;
